import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import "./surveyQuestions.css";
import { CannedType, ICannedMessage, LoginResponse, SurveyQuestionsForUserModel, wgLogType, wgModules } from "../../models";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import TreeNode from "primereact/treenode";
import { wglcsApiService } from "../../services/WglcsApiService";
import _ from "lodash";
import { NavLink } from "react-router-dom";
import ConfirmDialog from "../alert/Dialog";
import moment from "moment";
// import Cookies from "universal-cookie";
import "primeflex/primeflex.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { wgLogs } from "../../constants/wgLogs";
import { utils } from "../../utils";
import SnackBar from "../../views/alert/Toast";
import { Ripple } from 'primereact/ripple';
import { cookieService } from "../../services/CookieService";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import EventEmitter, { Events } from "../../services/eventemitter";
import Spinner from "../../components/spinner/spinner";
import Loader from "react-loader-spinner";

import { t } from "i18next";
import CannedMessagesComponent from "../../components/chat/CannedMessagesComponent";
import SurveyCannedMessages from "./SurveyCannedMessages";

const TimeStampFormat = "YYYY-MM-DD HH:mm:ss";
// const cookies = new Cookies();
interface SurveyQuestionsState {
    displayBasic: boolean;
    position: string;
    nodes: any[];
    expandedKeys: any;
    userData: LoginResponse;
    loading: boolean;
    question: SurveyQuestionsForUserModel[];
    answerId: number;
    timeIn: string;
    timeOut: string;
    confirmationMessage: string;
    confirmation: boolean;
    header: string;
    topPosition: boolean;
    topDialogText: string;
    submit: boolean;
    globalFilterData: any;
    result: ICannedMessage[];
    visible: boolean,
    isSurveySubmitted: boolean
}
interface SurveyQuestionProps {
    // question: SurveyQuestionsForUserModel[];
    isOpenSurvey: boolean,
    oneQuestion: any
    handleCloseSurvey: any,
    isOpenForcfully: boolean

}
class surveyQuestions extends Component<SurveyQuestionProps, SurveyQuestionsState> {
    userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
    constructor(props) {
        super(props);
        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        this.state = {
            displayBasic: true,
            position: "center",
            nodes: [],
            expandedKeys: {},
            userData: userData,
            loading: true,
            question: [],
            answerId: 0,
            timeIn: "",
            timeOut: "",
            header: t("Survey.header"),
            confirmationMessage: "",
            confirmation: false,
            topPosition: false,
            topDialogText: "",
            submit: false,
            globalFilterData: null,
            result: [],
            visible: true,
            isSurveySubmitted: false

        };
        this.onChangeValue = this.onChangeValue.bind(this);
        this.onHide = this.onHide.bind(this);
    }

    componentDidUpdate(prevProps: Readonly<SurveyQuestionProps>, prevState: Readonly<SurveyQuestionsState>, snapshot?: any): void {
        // if(this.props.isOpenSurvey!=this.state.visible){
        //     this.setState({visible:true})
        // }
    }
    componentDidMount = async () => {
        let loginData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        // let storedSurveyQuestions = this.getPersistedSurveyQuestions();
        if (loginData) {
            // let lastObj = storedSurveyQuestions[storedSurveyQuestions?.length - 1];
            // let questionToRender = _.filter(storedSurveyQuestions, (item) => item.questionId === lastObj.questionId);
            let result = (await wglcsApiService.getcannedmessagesbywebsite(this.props.oneQuestion[0].websiteId, this.state.userData.userLoginData.languageId)).data?.data ?? [];
            result = result.filter((item) => item.color.toLowerCase() !== "black");
            var nodes = this.transformToTree(result);
            this.setState({ nodes: nodes, result: result, loading: false, question: this.props.oneQuestion, timeIn: new Date().toString() });
            this.PersistSurveyQuestionToLocalStorage(this.props.oneQuestion)

            if (!this.props.isOpenForcfully) {
                cookieService.setElectronCookies("RoutedSurveyCount", 1 + parseInt(cookieService.getElectronCookies("RoutedSurveyCount")))
            }
        }
    };

    getPersistedSurveyQuestions(): SurveyQuestionsForUserModel[] {
        return JSON.parse(localStorage.getItem("surveyQuestions")!);
    }

    PersistSurveyQuestionToLocalStorage(surveyQuestions: SurveyQuestionsForUserModel[]) {
        var questionNo1: any = this.getPersistedSurveyQuestions()
        if (questionNo1 != null && questionNo1 != undefined && questionNo1?.length > 0 && !this.props.isOpenForcfully) {
            questionNo1 = questionNo1
        }
        else {
            questionNo1 = []
        }

        let final = [...questionNo1, ...surveyQuestions]
        localStorage.setItem("surveyQuestions", JSON.stringify(final));
    }

    removeSurveyQuestion(surveyQuestionId: number) {
        var existingSurveyQuestions = this.getPersistedSurveyQuestions();
        let data = existingSurveyQuestions.filter((item) => item.questionId !== surveyQuestionId);
        this.PersistSurveyQuestionToLocalStorage(data);
    }

    transformToTree(data: ICannedMessage[]): TreeNode[] {
        var nodes = _.chain(data)
            .filter((f: ICannedMessage) => f.parentId === -1)
            .map((item) => this.fromCannedToTreeNode(item))
            .valueOf();
        this.fillTreeRecursive(nodes, data);

        return nodes;
    }

    fromCannedToTreeNode(item: ICannedMessage): TreeNode {
        item.messageText = item.messageText ?? item["descr"];
        return { data: item, key: (item.messageID ?? item["id"]).toString() } as TreeNode;
    }

    fillTreeRecursive(nodes: TreeNode[], data: ICannedMessage[]) {
        for (let index = 0; index < nodes.length; index++) {
            const element = nodes[index];
            element.children = _.chain(data)
                .filter((f: ICannedMessage) => f.parentId === (element.data as ICannedMessage).messageID)
                .map((item) => this.fromCannedToTreeNode(item))
                .valueOf();

            this.fillTreeRecursive(element.children, data);
        }
    }

    onChangeValue(event) {
        this.setState({ answerId: event.target.value });
    }

    onHide() {
        this.setState({ displayBasic: false });
    }

    afterSubmit = (questionId) => {
        cookieService.setElectronCookies("RoutedSurveyCount", parseInt(cookieService.getElectronCookies("RoutedSurveyCount")) - 1);
        this.removeSurveyQuestion(questionId)
        EventEmitter.emit(Events.route2ndSurvey, "");
    }

    sendSurveyBroadcast = () => {
        const unSentChatBroadCast = new BroadcastChannel("survey_count_notify")
        unSentChatBroadCast.postMessage("survey_count_notify")
    }

    onSubmit = async (e) => {
        if (e) {
            var obj = {
                questionTime: moment.utc(this.state.timeIn).local().format(TimeStampFormat),
                answerTime: moment.utc(new Date().toString()).local().format(TimeStampFormat),
                answerId: this.state.answerId,
                questionId: this.state.question[0].questionId,
                userId: this.state.userData.userLoginData.userId,
                surveryPushedInComment: false,
            };
            let userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
            if (userData) {
                var res = await wglcsApiService.saveSurveyResultwithPopUpTime(obj);
                if (res?.data?.status) {

                    let correctOption = this.state.question.filter((item) => item.isCorrect === true);
                    // localStorage.removeItem("surveyQuestions");

                    if (correctOption[0].answerId?.toString() === this.state.answerId?.toString()) {
                        this.setState({
                            isSurveySubmitted: true,
                            topPosition: true,
                            submit: true,
                            topDialogText: t("Survey.correctAnswerMessage"),
                        });

                        this.afterSubmit(obj.questionId)
                        if (obj != null)
                            wgLogs.saveLog(wgLogType.Insert, wgModules.SurveyQuestionsLogs, obj?.questionId?.toString(), obj, "Survey submitted ");
                    } else {

                        this.setState({
                            isSurveySubmitted: true,
                            topPosition: true,
                            submit: true,
                            topDialogText: t("Survey.Wrong-option-message") +
                                correctOption[0].answerText + "," + t("Survey.beCareful-message"),
                        });
                        // cookies.set("RoutedSurveyCount", parseInt(cookies.get("RoutedSurveyCount")) - 1);
                        this.afterSubmit(obj.questionId)

                        if (obj != null)
                            wgLogs.saveLog(
                                wgLogType.Insert,
                                wgModules.SurveyQuestionsLogs,
                                obj?.questionId?.toString(),
                                obj,
                                "Survey failed to submit " + res.statusText
                            );
                    }
                    this.sendSurveyBroadcast()
                }
            } else {
                alert(t("notificationMessages.login"));
                window.location.reload();
            }
        }
    };
    confirmBeforeSubmit = () => {
        localStorage.setItem("surveyRouting", "false")
        let loginData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        if (loginData) {
            if (!this.state.answerId) {
                this.setState({ topPosition: true, topDialogText: t("notificationMessages.ChooseAnser") });
                //  EventEmitter.emit(Events.DisplayApiErrorResponse, t("notificationMessages.ChooseAnser"))
            } else {
                this.setState({ confirmationMessage: t("ConfirmationDialog.save-message"), confirmation: true });
            }
        } else {
            alert(t("notificationMessages.logout"));
        }
    };

    handleClose = (visible) => {
        this.setState({ confirmation: visible });
    };

    onHideTopDialog = () => {
        if (this.state.submit) {
            this.setState({ topPosition: false });
            window.close();
        } else {
            this.setState({ topPosition: false });
        }
    };

    renderFooter() {
        return (
            <div>
                <button className="wgbtn p-ripple" style={{ padding: "4px 20px;" }} onClick={() => this.onHideTopDialog()}>
                    <Ripple />   {t("OK")}
                </button>
            </div>
        );
    }

    rowClassName = (node: TreeNode) => {
        var obj = {};
        obj[`background-${(node.data as ICannedMessage).color?.toLowerCase() ?? "none"}`] = true;
        return obj;
    };

    filter = (e) => {
        var globalFilterKey = (e.target as any).value.toLowerCase() as string;
        this.setState({ globalFilterData: globalFilterKey });

        // let filteredArray = this.state.result?.filter((item) => item.messageText.toLowerCase().includes(e.currentTarget.value?.toLowerCase()));

        // let nodes = this.transformToTree(globalFilterKey);
        // this.setState({ nodes: nodes });
    };

    getHeader() {
        return (
            <div className="p-input-icon-left">
                <i className="pi pi-search"></i>
                <InputText type="search"
                    onInput={(e) => this.filter(e)}
                    placeholder={t("Search")} />
            </div>
        );
    }

    handleCloseSurvey = () => {
        localStorage.setItem("surveyRouting","false")
        EventEmitter.emit(Events.displaySurveyButtonRequest, true)
        this.props.handleCloseSurvey()
        this.sendSurveyBroadcast()
    }

    handleCloseAlertBox = () => {
        if (this.state.isSurveySubmitted) {
            this.props.handleCloseSurvey()
        }
        this.setState({ topPosition: false })
    }

    render() {
        let header1 = this.getHeader();
        return (
            <>
                <Modal className="survey-qus-modal" isOpen={this.state.visible} size="lg" zIndex={1051}>
                    <ModalHeader>
                        {t("Survey.header")}
                        <i className="pi pi-times" style={{ float: "right" }} onClick={() => this.handleCloseSurvey()}></i>
                    </ModalHeader>
                    <ModalBody>
                        <div className="survey container">
                            <h5 className="top-header">{this.state?.question[0]?.domainName ? this.state?.question[0]?.domainName : t("ReportComponent.Website")}</h5>
                            <div className="survey-question row">
                                <div className="col-sm-6 question-style px-3">
                                    {this.state.question?.length == 0 ? (
                                        <Spinner />
                                       ) : (
                                        <><h6>{this.state.question && this.state.question[0]?.questionText}</h6>
                                            <span onChange={this.onChangeValue}>
                                                {this.state.question &&
                                                    this.state.question?.filter(x=>x.questionId==this.state.question[0]?.questionId)?.map((item) => {
                                                        return (
                                                            <>
                                                                {" "}
                                                                <label>
                                                                    <input type="radio" value={item.answerId} name="radio" /> <span>{item.answerText}</span>
                                                                    <br />
                                                                </label>
                                                            </>
                                                        );
                                                    })}
                                            </span>
                                            <button onClick={() => this.confirmBeforeSubmit()} className="wgbtn p-ripple">
                                                <Ripple />  {t("wg-buttons.Submit")}
                                            </button>
                                        </>)}
                                </div>
                                <div className="canned-style col-sm-6  px-3 ">
                                    <div className="card">  
                                        <SurveyCannedMessages
                                            websiteName={""}
                                            cannedHeight={0}
                                            userId={this.userData.userLoginData.userId}
                                            languageId={1}
                                            websiteId={parseInt(this.props.oneQuestion[0].websiteId)}
                                            type={CannedType.Website}
                                            visitorId=""
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <ConfirmDialog
                            header={this.state.header}
                            visible={this.state.confirmation}
                            message={this.state.confirmationMessage}
                            handleClose={(e) => this.handleClose(e)}
                            handleAccept={(e, mode) => this.onSubmit(e)}
                        />
                    </ModalBody>
                </Modal>

                <Modal zIndex={1052} isOpen={this.state.topPosition} className="survey-error">
                    <ModalHeader>{t("Survey.header")}</ModalHeader>
                    <ModalBody>{this.state.topDialogText}</ModalBody>
                    <ModalFooter>
                        <button className="wgbtn p-ripple" onClick={() => this.handleCloseAlertBox()}>
                            <Ripple /> {t('Ok')}
                        </button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
export default surveyQuestions;
